import { Atom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { seasonOptionsAtom, selectedSeasonsAtom } from '@/atoms/filters/highLevel/seasons';
import { useGetFilteredOptions } from '@/hooks/useGetFilteredOptions';
import { GamesFilterType } from '@/hooks/useGetGamesByFilter';
import { FormattedGame } from '@/types/game';
import { NumberOption } from '@/types/generic';
import { RadarFilterSummaryItem } from './RadarFilterSummaryItem';

export const RadarFilterSeasonSummary = ({
  filteredGamesDataAtom,
  selectedGamesAtom,
}: {
  filteredGamesDataAtom: Atom<Promise<FormattedGame[]>>;
  selectedGamesAtom: Atom<Promise<NumberOption[]>>;
}) => {
  const { t } = useTranslation('entity');
  const filteredCompetitionOptions = useGetFilteredOptions(
    seasonOptionsAtom,
    filteredGamesDataAtom,
    selectedGamesAtom,
    GamesFilterType.SEASON,
  );

  return (
    <RadarFilterSummaryItem
      label={t('season_one')}
      options={filteredCompetitionOptions}
      selectedOptions={useAtomValue(selectedSeasonsAtom)}
    />
  );
};
